import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import HomePage from "./components/pages/Home";
import AboutPage from "./components/pages/About";
import ContactPage from "./components/pages/Contact";
import AuthPage from "./components/pages/Auth/Auth";
import PrivacyPage from "./components/pages/Privacy/PrivacyPolicy";
import CookiePage from "./components/pages/Privacy/CookiePolicy";
import NotFound from "./components/pages/NotFound";
import Navbar from "./components/shared/Navbar";
import Footer from "./components/shared/Footer";
import CourseList from "./components/pages/Courses/CourseList";
import LessonList from "./components/pages/Courses/LessonList";
import PracticeList from "./components/pages/Practice/PracticeList";
import Lesson from "./components/pages/Lesson/Lesson";
import PathCards from "./components/pages/Practice/PathCards";
import PracticeRouter from "./components/pages/Practice/PracticeRouter";

import Playground from "./components/pages/Lesson/Playground";
import ContinuousPractice from "./components/pages/Lesson/ContinuousPractice";
import Interview from "./components/pages/Lesson/Interview";
import CodeCohortLanding from "./components/pages/CodeCohort/CodeCohortLanding";
import CodeCohortLearn from "./components/pages/CodeCohort/CodeCohortLearn";
import IntegrationCredentials from "./components/pages/Lesson/IntegrationCredentials";


import DataInstallation from "./components/pages/DataInstallation";
import CompeteHome from "./components/pages/Competition/CompeteHome";
import CompetitionInfo from "./components/pages/Competition/CompetitionInfo";
import CompetitionRules from "./components/pages/Competition/CompetitionRules";
import CompetitionChallenge from "./components/pages/Competition/CompetitionChallenge";
import EventPage from "./components/pages/Event";
import CollabPage from "./components/pages/Collab";
import AdventPage from "./components/pages/Advent/AdventPage";
import DeployPage from "./components/pages/Deployment/DeployPage";

import { getUser } from "./components/features/auth/authSlice";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import AdventChallenge from "./components/pages/Competition/AdventChallenge";
import Advent2025Challenge from "./components/pages/Competition/Advent2025Challenge";
import ApexAfterDark from "./components/pages/ApexAfterDark/ApexAfterDark";
import AdventOfApex2025 from "./components/pages/Advent2025/AdventOfApex2025";

import SimulationList from "./components/pages/Simulations/SimulationList";
import MithraShell from "./components/pages/Mithra/MithraShell";
import MithraDashboard from "./components/pages/Mithra/MithraDashboard";
import MithraBoard from "./components/pages/Mithra/MithraBoard";
import MithraTicket from "./components/pages/Mithra/MithraTicket";
import MithraWiki from "./components/pages/Mithra/MithraWiki";
import ReviewForm from "./components/pages/Review/ReviewForm";

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUser());
  }, [dispatch]);

  const { user } = useSelector((state) => state.auth);

  return (
    <Router>
      <AppContent user={user} />
    </Router>
  );
}

// Split out so it can read the current location (must live under <Router>). The
// A simulation workspace (/simulations/:slug/*) renders its own enterprise
// chrome, so the Camp Apex Navbar/Footer are hidden on those routes for full
// immersion. The /simulations catalog itself keeps the normal chrome.
function AppContent({ user }) {
  const location = useLocation();
  const hideChrome =
    location.pathname.startsWith("/simulations/") ||
    location.pathname.startsWith("/mithra") ||
    location.pathname.startsWith("/review");

  return (
    <>
      {/* <Header text="Camp Apex" /> */}
      <div className="flex flex-col min-h-screen bg-zinc-900">
        {!hideChrome && <Navbar user={user[0]?.instanceUrl} />}{" "}
        {/*Not happy with this*/}
        <div className="flex-grow">
          <Routes>
              <Route exact path="/" element={<HomePage />}></Route>
              <Route exact path="/auth" element={<AuthPage />}></Route>
              <Route exact path="/about" element={<AboutPage />}></Route>
              <Route exact path="/contact" element={<ContactPage />}></Route>
              <Route
                exact
                path="/review/camp-lwc"
                element={<ReviewForm />}
              ></Route>
              <Route
                exact
                path="/deploy/:package-name"
                element={<DeployPage />}
              ></Route>
              {/* <Route exact path="/advent" element={<AdventPage />}></Route> */}
              <Route exact path="/advent/2024" element={<AdventPage />}></Route>
              <Route
                exact
                path="/advent/2025"
                element={<AdventOfApex2025 />}
              ></Route>
              <Route
                exact
                path="/advent/2025/:tabId"
                element={<AdventOfApex2025 />}
              ></Route>

              {/* <Route
                exact
                path="/practice/flow-into-apex"
                element={<FlowIntoApexPage />}
              ></Route> */}

              <Route exact path="/compete" element={<CompeteHome />}></Route>
              <Route
                exact
                path="/compete/:tag"
                element={<CompetitionInfo />}
              ></Route>
              <Route
                exact
                path="/advent/apex-week-of-horror"
                element={<ApexAfterDark />}
              ></Route>
              {/* <Route
                exact
                path="advent/:tag/:slug"
                element={<AdventChallenge />}
              ></Route> */}
              <Route
                exact
                path="/compete/:tag/:challengeId"
                element={<CompetitionChallenge />}
              ></Route>
              <Route
                exact
                path="/competition-rules"
                element={<CompetitionRules />}
              ></Route>
              <Route
                exact
                path="/advent/advent-2025/:slug"
                element={<Advent2025Challenge />}
              ></Route>
              <Route
                exact
                path="/advent/:tag/:slug"
                element={<AdventChallenge />}
              ></Route>
              <Route exact path="/privacy" element={<PrivacyPage />}></Route>
              <Route exact path="/cookie" element={<CookiePage />}></Route>
              <Route exact path="/notfound" element={<NotFound />}></Route>
              <Route exact path="/events" element={<EventPage />}></Route>
              <Route exact path="/collab" element={<CollabPage />}></Route>
  
              <Route path="/6-week-challenge" element={<CodeCohortLanding />} />
              <Route path="/6-week-challenge/learn" element={<CodeCohortLearn />} />
              <Route path="/6-week-challenge/learn/:challengeSlug" element={<CodeCohortLearn />} />
  
              <Route path="/*" element={<NotFound />}></Route>
              <Route
                path="/courses"
                element={
                  // <PrivateRoute>
                  <CourseList />
                  // </PrivateRoute>
                }
              />
              <Route
                path="/projects"
                element={
                  // <PrivateRoute>
                  <CourseList />
                  // </PrivateRoute>
                }
              />
              <Route path="/courses/:courseName" element={<CourseList />} />

              <Route path="/course/:slug" element={<LessonList />} />
              <Route path="/lesson/:lessonIdOrSlug" element={<Lesson />} />
              <Route
                path="/integration-credentials"
                element={
                  <div className="max-w-2xl mx-auto px-4 py-10">
                    <IntegrationCredentials />
                  </div>
                }
              />
              <Route path="/practice" element={<PathCards />} />
              <Route path="/practice/:role/" element={<PracticeRouter />} />
              <Route path="/interview/okta/" element={<Interview />} />
              <Route
                path="/practice/:role/:course"
                element={<PracticeList />}
              />
              <Route
                path="/practice/:role/:course/:lessonIdOrSlug"
                element={<Lesson />}
              />
              <Route path="/playground" element={<Playground />} />
              {/* <Route
                path="/practice/flow-into-apex/:lessonIdOrSlug"
                element={<Lesson />}
              /> */}
              {/* <Route
                path="/practice/:course/:lessonIdOrSlug"
                element={<FlowIntoApexPage />}
              />
              <Route
                path="/practice/:course/:lessonIdOrSlug"
                element={<FlowIntoApexPage />}
              /> */}

              <Route
                path="/data-installation/:dataKey"
                element={<DataInstallation />}
              />

              {/* Job Simulations - catalog of immersive enterprise projects */}
              <Route path="/simulations" element={<SimulationList />} />

              {/* A simulation workspace - generic, driven by the DB-seeded config
                  for :slug (company, people, theme, board, wiki). */}
              <Route path="/simulations/:slug" element={<MithraShell />}>
                <Route index element={<MithraDashboard />} />
                <Route path="board" element={<MithraBoard />} />
                <Route path="ticket/:cardKey" element={<MithraTicket />} />
                <Route path="wiki" element={<MithraWiki />} />
                <Route path="wiki/:pageSlug" element={<MithraWiki />} />
              </Route>

              {/* Back-compat: the old /mithra/* URLs redirect into the generic
                  workspace. */}
              <Route path="/mithra" element={<Navigate to="/simulations/mithra" replace />} />
              <Route path="/mithra/*" element={<Navigate to="/simulations/mithra" replace />} />
            </Routes>
          </div>
          {!hideChrome && <Footer className="mt-auto" />}
        </div>
    </>
  );
}

export default App;
